<template>
  <div class="app-navbar-container">
    <div class="app-navbar-left">
      <img :src="logoIllimity" alt="image">
      <span class="relititle">RELI</span>
      <ul>
        <li v-for="route in showRoutes" :id="'navbar_' + route.name" :key="route.path">
          <a @click="goTo(route)">
            {{ route.meta.title }}
          </a>
        </li>
      </ul>
    </div>
    <div class="app-navbar-right">
      <el-popover placement="bottom" title="" trigger="click">
        <div class="container-profile-selector">
          <div class="profile_popup_container">
            <div class="container-options-acc">
              <div class="lang-switch-cont"><span class="brains-strong--600">{{ $t('lang') }}:</span> <langSwitcher /></div>
              <el-divider />
              <div><el-button class="brains-type1-btn" @click="loadSearches()">{{ $t('saved-searches') }}</el-button></div>
              <el-divider />
              <div><el-button class="brains-type1-btn" @click="logoutApp()">{{ $t('layout.logout') }}</el-button></div>
            </div>
          </div>
        </div>
        <el-button
          slot="reference"
          class="profilename_container outside_cont"
        ><span>{{ name }}	&#8744;</span></el-button>
      </el-popover>
    </div>
    <el-dialog v-if="showloadedvaluations" :visible.sync="showloadedvaluations" class="savevaluationdialog" width="70%" center>
      <div class="container-saved-searches">
        <div class="container-buscador-searches mt-1 mb-2">
          <div class="col-2">
            <el-input v-model="search" :placeholder="$t('find-saved-search')" icon="search" class="brains-type1-number-input" />
          </div>
        </div>
        <div v-show="loading" class="brains-map-loader navloader" />
        <table class="brains-table2 saved-search-table" aria-describedby="savedvaluations">
          <thead>
            <tr>
              <th>{{ $t("date") }}</th>
              <th>{{ $t("userData.name") }}</th>
              <th>{{ $t("assetData.address") }}</th>
              <th>{{ $t("userData.actions") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in valuationDataFiltered" :id="index" :key="index">
              <td>{{ getFormattedDateHours(item.date) }}</td>
              <td>{{ item.valuationName }}</td>
              <td>{{ item.address }}</td>
              <td>
                <button class="brains-type1-btn" @click="handleSearch(item)">{{ $t("search") }}</button>
                <button class="brains-type1-btn ml-1" @click="handleRemove(item)">{{ $t("remove") }}</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import logoBrainsre from '@/assets/logo_brainsre.png'
import logoIllimity from '@/assets/logo.png'
import i18n from '@/i18n'
import { mapState } from 'vuex'
import langSwitcher from '@/components/designComponents/langSwitcher'
export default {
  name: 'AppNavbar',
  components: { langSwitcher },
  data() {
    return {
      logoBrainsre: logoBrainsre,
      logoIllimity: logoIllimity,
      activeNav: 'home',
      showloadedvaluations: false,
      search: '',
      loading: false
    }
  },
  computed: {
    ...mapState('user', {
      name: (state) => state.name
    }),
    showRoutes: {
      get() {
        return [
          {
            path: '/explore',
            name: 'explore',
            meta: { title: i18n.t('router.explore') }
          },
          {
            path: '/valuation',
            name: 'valuation',
            meta: { title: i18n.t('router.valuation') }
          },
          {
            path: '/portfolio',
            name: 'portfolio',
            meta: { title: i18n.t('router.portfolio') }
          },
          {
            path: '/reports',
            name: 'reports',
            meta: { title: i18n.t('router.reports') }
          }
        ]
        // return this.$router.options.routes.filter(item => { return item.hidden === false })
      }
    },
    valuationDataFiltered: {
      get() {
        var res = this.valuationData.filter((item) => {
          if (this.search === '') return true
          if ((item.valuationName.toLowerCase().includes(this.search.toLowerCase()) || item.address.toLowerCase().includes(this.search.toLowerCase()) || item.date.includes(this.search))) {
            return item
          } else { return false }
        })
        return res
      }
    }
  },
  created() {
    const vm = this
    setTimeout(() => {
      vm.setActiveClass()
    }, 100)
  },
  methods: {
    handleRemove(valu) {
      const vm = this
      vm.$confirm(vm.$t('suredeletevaluation'), 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        // debugger
        vm.$store.dispatch('valuations/RemoveValuation', { Id: valu.id }).then((response) => {
          vm.$loading = false
          vm.showloadedvaluations = false
          setTimeout(() => { vm.loadSearches() }, 500)
        })
      })
    },
    handleSearch(valu) {
      const vm = this
      vm.loading = true
      setTimeout(() => { vm.handleSearch2(valu) }, 100)
    },
    handleSearch2(valu) {
      const vm = this
      vm.loading = true
      vm.$store.dispatch('valuations/LoadValuation', { Id: valu.id }).then((response) => {
        vm.showloadedvaluations = false
        const data = JSON.parse(response.data)
        response.data = data
        // debugger
        const place = {
          geometry: {
            location: {
              lat: function() {
                return data.position.latitude
              },
              lng: function() {
                return data.position.longitude
              }
            }
          },
          formatted_address: response.address
        }
        // debugger
        vm.$store.dispatch('valuations/setFromSearch', true).then(() => {
          // vm.loading = false
          vm.goTo({
            path: '/valuation',
            name: 'valuation',
            meta: { title: i18n.t('router.valuation') }
          })
          setTimeout(() => {
            vm.loading = false
            vm.$store.dispatch('location/searchlocations', place).then(() => {
              vm.$store.dispatch('valuations/setcomparables', data).then(() => {
                vm.$root.$emit('loadsavevaluation', response)
                setTimeout(() => { vm.$store.dispatch('valuations/setFromSearch', false) }, 1000)
              })
            })
          }, 500)
        })
      }).catch((error) => {
        vm.loading = false
        console.error(error)
        vm.$message({
          message: vm.$t('errorgettintvaluations'),
          type: 'error'
        })
      })
    },
    getFormattedDateHours(date) {
      if (date !== null && date !== undefined) {
        return this.$moment(date).format('DD/MM/YYYY HH:mm')
      }
      return ''
    },
    loadSearches() {
      const vm = this
      vm.$store.dispatch('valuations/GetSavedValuation').then((data) => {
        vm.loading = false
        vm.valuationData = data
        vm.showloadedvaluations = true
        vm.search = '*'
        vm.search = ''
        console.log(vm.valuationDataFiltered)
      }).catch((error) => {
        vm.loading = false
        console.error(error)
        vm.$message({
          message: vm.$t('errorgettintvaluations'),
          type: 'error'
        })
      })
    },
    setActiveClass() {
      var listArray = Array.from(document.querySelector('.app-navbar-left ul').children)
      listArray.forEach(element => {
        element.classList.remove('active-navbar')
      })
      if (this.activeNav === 'home' || this.activeNav === '/') {
        document.getElementById('navbar_explore').classList.add('active-navbar')
      } else {
        document.getElementById('navbar_' + this.activeNav).classList.add('active-navbar')
      }
    },
    logoutApp() {
      this.$store.dispatch('user/logout')
    },
    goTo(path) {
      const vm = this
      vm.activeNav = path.name
      setTimeout(() => {
        vm.setActiveClass()
        vm.$store.dispatch('user/setactiveNav', vm.activeNav)
      }, 100)
    }
  }
}
</script>
<style lang="scss" scoped>
.app-navbar-container {
  display: flex;
  border-bottom: 1px solid lightgrey;
  height: 40px;
}
.navloader {
  position: relative;
  top: 2px;
  right: 10px;
}
.app-navbar-left {
  display: flex;

  .active-navbar {
    color: #1e3cff;
  }

  & > img {
    height: 40px;
  }

  & > ul {
    display: flex;
    gap: 15px;

    li {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: rgb(102, 102, 102);
      font-family: 'Montserrat-ExtraBold',sans-serif;
      cursor: pointer;

      a {
        padding: 7px;
        &:hover {
          box-shadow: 0 4px #1e3cff;
          color: #1e3cff;
        }
      }

    }
  }
}

.app-navbar-right {
  margin-right: 5px;
  margin-left: auto;
  display: flex;
  align-items: center;
}
.profilename_container {
    background-color: #1e3cff;
    border: 1px solid grey;
    padding: 6px 6px;
    color: white;
    cursor: pointer;
    height: 29px;
    border-radius: 10px;
    margin-left: 5px;

    &.outside_cont {
      font-weight: 700;

      &:hover {
        background-color: #009999;
      }
    }
  }

  .profilename_container--inside-popover {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: default;
    span {
      height: 100%;
      display: flex;
      justify-content: center;
      font-size: 1.5em;
      align-items: center;
    }
  }

  .profile_popup_container {
    // text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    hr {
      width: 100%;
    }
  }

  .btn-save-contact-container {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .container-img-name {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    line-height: 18px;
  }

  .container-options-acc {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-self: flex-start;
    width: 100%;
    cursor: pointer;
    font-weight: 700;
    color: #00b1ff;
    font-size: 13px;
    line-height: 20px;

    div a {
      text-decoration: none !important;
    }
  }
  .container-profile-selector {
    padding: 0 20px 0 15px;
    max-height: 500px;
    overflow: hidden;
  }

  .lang-switch-cont {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-top: 5px;
  }

  .relititle{
    margin-left: 10px;
    font-size: 2em;
    font-weight: 500;
  }
</style>
